<template>
  <v-container fluid>
    <v-card class="elevation-5 px-2 py-2 mt-2">
      <v-card-title autofocus>Projeção de sobrevivência</v-card-title>
      <h2 class="text-right mr-4" :style="deadlineText ? 'color:#f72047' : 'color:#02CE6E'">
        {{ deadlineText ? deadlineText : 'A empresa está saúdavel para enfrentar o período' }}</h2>
      <v-sparkline :value="this.$store.state.values" :labels="labels" :gradient="gradient" :smooth="radius"
        :padding="padding" :line-width="lineWidth" :stroke-linecap="cap" :gradient-direction="gradientDirection"
        :fill="fill" :type="type" :auto-line-width="autoLineWidth" auto-draw :show-labels="showLabels"
        :label-size="labelSize"></v-sparkline>
    </v-card>
    <v-card class="mt-8 elevation-5 px-2 py-2 text-center">
      <v-card-title>Saúde orçamentária</v-card-title>
      <v-card-text class="text-right">Percentual de gasto em relação ao caixa do período</v-card-text>
      <v-progress-circular class="mr-2 mb-2" :rotate="180" :size="100" :width="10" :value="this.$store.state.rentHealth"
        :color="color">
        <div style="font-size:10pt; text-align:center;">Aluguel<br>{{this.$store.state.rentHealth}}%</div>
      </v-progress-circular>
      <v-progress-circular class="mr-2 mb-2" :rotate="180" :size="100" :width="10"
        :value="this.$store.state.staffHealth" :color="color">
        <div style="font-size:10pt; text-align:center;">Pessoas<br>{{this.$store.state.staffHealth}}%</div>
      </v-progress-circular>
      <v-progress-circular class="mr-2 mb-2" :rotate="180" :size="100" :width="10"
        :value="this.$store.state.materialHealth" :color="color">
        <div style="font-size:10pt; text-align:center;">Operação<br>{{this.$store.state.materialHealth}}%</div>
      </v-progress-circular>
      <v-progress-circular class="mr-2 mb-2" :rotate="180" :size="100" :width="10"
        :value="this.$store.state.taxesHealth" :color="color">
        <div style="font-size:10pt; text-align:center;">Impostos<br>{{this.$store.state.taxesHealth}}%</div>
      </v-progress-circular>
      <v-progress-circular class="mr-2 mb-2" :rotate="180" :size="100" :width="10"
        :value="this.$store.state.debtsHealth" :color="color">
        <div style="font-size:10pt; text-align:center;">Dívidas<br>{{this.$store.state.debtsHealth}}%</div>
      </v-progress-circular>
      <v-progress-circular class="mr-2 mb-2" :rotate="180" :size="100" :width="10"
        :value="this.$store.state.otherHealth" :color="color">
        <div style="font-size:10pt; text-align:center;">Outros<br>{{this.$store.state.otherHealth}}%</div>
      </v-progress-circular>
    </v-card>
    <v-card  class="mt-8 elevation-5 px-2 py-2 text-center">
    <v-card-text class="title">
      Fale com um especialista agora e entenda como você pode melhorar seu desempenho financeiro neste momento.
    </v-card-text>
    <v-card-actions>
      <v-spacer />
    <v-btn :to="{name: 'index'}" color="black" dark width="180">Refazer</v-btn>
     <v-spacer />
    <v-btn href="https://meuatendimento.sebrae.com.br/sites/PortalSebrae/login" target="_BLANK" color="blue" dark width="180">Quero ajuda</v-btn>
     <v-spacer />
    </v-card-actions>
    </v-card>
  </v-container>
</template>

<script>
  export default {
    data: () => ({
      cap: 'round',
      gradient: [],
      showLabels: true,
      lineWidth: 2,
      labelSize: 4,
      radius: 9,
      padding: 8,
      labels: ['1° MÊS', '2° MÊS', '3° MÊS', '4° MÊS'],
      gradientDirection: 'left',
      fill: true,
      type: 'trend',
      autoLineWidth: false,
      color: 'blue',
      deadlineText: '',
    }),
    beforeRouteEnter(to, from, next) {
      document.body.scrollTop = 0; // For Safari
      document.documentElement.scrollTop = 0;

      next();
    },
    created() {
      if (this.$store.state.values.length === 0 || null) this.$router.push({
        name: 'index'
      });
      else {
        for (let i = 0; i < 4 && this.$store.state.deadline === null; i++) {
          if (parseFloat(this.$store.state.values[i]) <= 0.9) {
            this.$store.state.deadline = i;

            switch (i) {
              case 0:
                this.deadlineText = 'A empresa está em risco imediato';
                break;

              case 1:
                this.deadlineText = 'A empresa estará em risco no 2° mês';
                break;

              case 2:
                this.deadlineText = 'A empresa estará em risco no 3° mês';
                break;

              case 3:
                this.deadlineText = 'A empresa estará em risco no 4° mês';
                break;

              default:
                break;
            }
          }
        }

        for (let i = 0; i < 4; i++) {
          if (this.$store.state.values[i] > 1.4) this.gradient.push('#02CE6E');
          else if (this.$store.state.values[i] > 0.9) this.gradient.push('#ffd200');
          else this.gradient.push('#f72047');
        }
      }
    }
  }
</script>